function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Teaser install overlay — replaces native confirm() for uninstalled games.
 * Opens the game's wiki/application link in a new tab when the user continues.
 */
var TeaserInstallTemplate = require('./teaser-install.template');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var TeaserInstallOverlay = /*#__PURE__*/function () {
  function TeaserInstallOverlay(app) {
    var _this = this;
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, TeaserInstallOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.link = '';
    app.connection.on('arcade-teaser-install-render-request', function () {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this.open(obj);
    });
  }
  return _createClass(TeaserInstallOverlay, [{
    key: "open",
    value: function open() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var game = obj.game || null;
      var game_mod = obj.game_mod || (game === null || game === void 0 ? void 0 : game.game_mod) || null;
      var title = obj.title || (game === null || game === void 0 ? void 0 : game.title) || (game_mod !== null && game_mod !== void 0 && game_mod.returnName ? game_mod.returnName() : '') || (game_mod === null || game_mod === void 0 ? void 0 : game_mod.name) || 'Game';
      var image = obj.image || (game_mod === null || game_mod === void 0 ? void 0 : game_mod.img) || (game === null || game === void 0 ? void 0 : game.image) || '';
      if (!image && game_mod) {
        try {
          var _game_mod$respondTo;
          image = ((_game_mod$respondTo = game_mod.respondTo('arcade-games')) === null || _game_mod$respondTo === void 0 ? void 0 : _game_mod$respondTo.image) || '';
        } catch (_) {}
      }
      this.link = obj.link || (game === null || game === void 0 ? void 0 : game.link) || (game_mod === null || game_mod === void 0 ? void 0 : game_mod.link) || '';
      this.overlay.show(TeaserInstallTemplate({
        title: title,
        image: image
      }));
      if (image) {
        this.overlay.setBackground(image);
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var btn = document.querySelector('.arcade-teaser-install [data-action="install"]');
      if (!btn) {
        return;
      }
      btn.onclick = function (e) {
        e.preventDefault();
        if (!_this2.link) {
          siteMessage('No install link is available for this game.', 2500);
          return;
        }
        _this2.overlay.remove();
        window.open(_this2.link, '_blank', 'noopener,noreferrer');
      };
    }
  }]);
}();
module.exports = TeaserInstallOverlay;